import { t } from 'i18next';
import { useState } from 'react';
import { CustomPicker } from 'react-color';
import { Hue, Saturation } from 'react-color/lib/components/common';
import tinycolor from 'tinycolor2';
import { ButtonWithPopover } from '@seeqdev/qomponents';

interface HueSaturationProps {
  color: string;
  onChange: (color: object) => void;
}

/**
 * Component of ColorPicker to pick color based on Hue + Saturation
 */
const HueSaturation = (props: HueSaturationProps) => {
  const color = tinycolor(props.color);
  const [showPopover, setShowPopover] = useState(false);

  const closeHueSaturationPicker = (open: boolean) => {
    setShowPopover(open);
  };

  return (
    <ButtonWithPopover
      trigger={
        <div
          className="colorPickerSwatch hsSwatch"
          data-testid="hsPickerButton"
          style={{ backgroundColor: color.toHexString() }}
          id="specHsPickerButton"
        />
      }
      tooltip={t('COLOR_PICKER.PICKER')}
      isOpen={showPopover}
      onOpenChange={closeHueSaturationPicker}
      placement="bottom">
      <div id="specHSPickerPopover" data-testid="hueSaturationPickerPopover">
        <div className="backgroundColorWhite tw:p-sq-10">
          <div className="tw:relative tw:mb-sq-5 tw:h-sq-150! tw:w-sq-150!" data-testid="specSaturationPicker">
            <Saturation hsv={color.toHsv()} hsl={color.toHsl()} onChange={(e) => props.onChange(e)} />
          </div>
          <div className="tw:relative tw:h-sq-10! tw:w-sq-150!" data-testid="specHuePicker">
            <Hue hsl={color.toHsl()} onChange={(e) => props.onChange(e)} />
          </div>
        </div>
      </div>
    </ButtonWithPopover>
  );
};

export const HueSaturationPicker = CustomPicker(HueSaturation);
